package com.example.mystybag.core.expected

import com.example.mystybag.core.helpers.WebLocaleComposition
import dev.icerock.moko.resources.desc.StringDesc

actual object LocaleHelper {
    // Web is locked to Bulgarian: ignore the requested language and always force "bg",
    // so no code path (settings, switcher, etc.) can flip the web UI to another language.
    actual fun updateLocaleAndShortcuts(language: String) {
        LogHelper.logEvent("[LocaleHelper JS] updateLocaleAndShortcuts: requested=$language, forcing bg")
        try {
            StringDesc.localeType = StringDesc.LocaleType.Custom("bg")
            WebLocaleComposition.bump()
        } catch (e: Exception) {
            LogHelper.logEvent("[LocaleHelper JS] updateLocaleAndShortcuts: exception ${e.message}")
            logException(e)
        }
    }
}
